import { css } from "@emotion/react";

import {
  ACTIONS_TOOLBAR_HEIGHT,
  SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT,
} from "@/view/ActionsToolbar/ActionsToolbar.style";

export const globalStyleOverrideCss = (isSmallScreen = true) =>
  css({
    // Only apply scroll padding when no element inside the sticky bar has focus.
    // This prevents the browser from scrolling the page when focusing elements
    // that are already visible in the sticky toolbar (LESS-5247), while still
    // ensuring elements below the bar scroll into view properly (LESS-4180).
    ":root:not(:has(#sticky-bar :focus))": {
      "--layout-scroll-padding-top": isSmallScreen
        ? `${SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT}`
        : `${ACTIONS_TOOLBAR_HEIGHT}`,
    },
  });
